import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
  AWSEmail: any;
  AWSIPAddress: any;
  AWSJSON: any;
  AWSPhone: any;
  AWSTime: any;
  AWSTimestamp: any;
  AWSURL: any;
};

export type AcknowledgmentDetails = {
  __typename?: 'AcknowledgmentDetails';
  date: Scalars['String'];
  fullName: Scalars['String'];
  source?: Maybe<AcknowledgmentSource>;
  userId: Scalars['ID'];
};

export enum AcknowledgmentSource {
  Portal = 'PORTAL',
  Sms = 'SMS'
}

export type ApplicationUser = {
  __typename?: 'ApplicationUser';
  displayName: Scalars['String'];
  emailAddress: Scalars['AWSEmail'];
  firstName: Scalars['String'];
  isAdminUser: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastUpdatedBy?: Maybe<Scalars['ID']>;
  lastUpdatedDate?: Maybe<Scalars['String']>;
  permissions: Array<UserPermission>;
  userId: Scalars['ID'];
};

export type ApplicationUserInput = {
  displayName: Scalars['String'];
  emailAddress: Scalars['AWSEmail'];
  firstName: Scalars['String'];
  isAdminUser: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  lastName: Scalars['String'];
  permissions: Array<UserPermission>;
};

export type AssignedEmergencyContactDetails = {
  __typename?: 'AssignedEmergencyContactDetails';
  emergencyContactId?: Maybe<Scalars['Int']>;
  emergencyContactName?: Maybe<Scalars['String']>;
  incidentId?: Maybe<Scalars['ID']>;
};

export type AttachmentInfo = {
  __typename?: 'AttachmentInfo';
  contentId?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  include?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  qualifier?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
};

export type AttachmentInfoInput = {
  contentId?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  include?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
};

export type BlockReason = {
  __typename?: 'BlockReason';
  cacheItem?: Maybe<BlockedContentCacheItem>;
  excerpts?: Maybe<Array<Maybe<Scalars['String']>>>;
  keyword?: Maybe<Scalars['String']>;
  moreExcerpts?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  regex?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  videoItem?: Maybe<BlockedVideoCacheItem>;
};

export type BlockReasonInput = {
  cacheItem?: InputMaybe<BlockedContentCacheItemInput>;
  excerpts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyword?: InputMaybe<Scalars['String']>;
  moreExcerpts?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  regex?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  videoItem?: InputMaybe<BlockedVideoCacheItemInput>;
};

export type BlockedContentCacheItem = {
  __typename?: 'BlockedContentCacheItem';
  contentKey?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['AWSTimestamp']>;
  url?: Maybe<Scalars['String']>;
};

export type BlockedContentCacheItemInput = {
  contentKey?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['AWSTimestamp']>;
  url?: InputMaybe<Scalars['String']>;
};

export type BlockedVideoCacheItem = {
  __typename?: 'BlockedVideoCacheItem';
  contentHash?: Maybe<Scalars['String']>;
  frames?: Maybe<Array<BlockedContentCacheItem>>;
  sensitivity?: Maybe<Scalars['Int']>;
};

export type BlockedVideoCacheItemInput = {
  contentHash?: InputMaybe<Scalars['String']>;
  frames?: InputMaybe<Array<BlockedContentCacheItemInput>>;
  sensitivity?: InputMaybe<Scalars['Int']>;
};

export type ChatWorkItem = WorkItem & {
  __typename?: 'ChatWorkItem';
  apsIds?: Maybe<Array<Scalars['ID']>>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  author?: Maybe<Scalars['String']>;
  blockReasons?: Maybe<Array<BlockReason>>;
  blockedUserId?: Maybe<Scalars['ID']>;
  bundleDigest?: Maybe<Scalars['String']>;
  bundled?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  customerId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  districtId: Scalars['ID'];
  districtIdShort?: Maybe<Scalars['String']>;
  districtInfo?: Maybe<DistrictInfo>;
  districtName?: Maybe<Scalars['String']>;
  districtNotes?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  events?: Maybe<Array<WorkItemEventRecord>>;
  externalAuthor?: Maybe<Scalars['Boolean']>;
  extraInfo?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupIdShort?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  gsmEmailSetting?: Maybe<GsmEmailSetting>;
  id: Scalars['ID'];
  imageCacheIds?: Maybe<Array<Scalars['String']>>;
  inappropriateContentReasons?: Maybe<Array<InappropriateContentReason>>;
  incidentIds?: Maybe<Array<Scalars['ID']>>;
  itemData?: Maybe<Scalars['AWSJSON']>;
  logicalLocationId?: Maybe<Scalars['ID']>;
  messageId?: Maybe<Scalars['String']>;
  ncmecId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  occurrenceDate?: Maybe<Scalars['String']>;
  safetyAudit?: Maybe<Scalars['Boolean']>;
  safetyRepId?: Maybe<Scalars['ID']>;
  studentInfo?: Maybe<StudentInfo>;
  studentTimezone?: Maybe<Scalars['String']>;
  unbundled?: Maybe<Scalars['Boolean']>;
  uniqueId?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userIdShort?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  workItemEntityType: WorkItemEntityType;
  workItemSource?: Maybe<WorkItemSource>;
  workItemStatus?: Maybe<WorkItemStatus>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export type CompleteItemResponse = {
  __typename?: 'CompleteItemResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateDistrictSchoolGuidanceResult = {
  __typename?: 'CreateDistrictSchoolGuidanceResult';
  created?: Maybe<Array<Maybe<DistrictSchoolGuidance>>>;
  failed?: Maybe<Array<Maybe<DistrictSchoolGuidance>>>;
};

export type DatadogMetric = {
  metricKey: Scalars['String'];
  metricType?: InputMaybe<Scalars['String']>;
  metricValue: Scalars['Int'];
};

export type DatadogMetricInput = {
  actionTaken?: InputMaybe<EventAction>;
  application: Scalars['String'];
  environment: Environment;
  metrics: Array<DatadogMetric>;
  queue?: InputMaybe<WorkItemEntityType>;
  selectedCategories?: InputMaybe<Array<InputMaybe<InappropriateContentReason>>>;
  tags?: InputMaybe<Array<DatadogTag>>;
  warningEventType?: InputMaybe<WarningEventType>;
  workItemId?: InputMaybe<Scalars['String']>;
  workerId: Scalars['String'];
  workerName?: InputMaybe<Scalars['String']>;
  workerPermissions?: InputMaybe<Array<InputMaybe<WorkerPermissionInput>>>;
};

export type DatadogTag = {
  tagKey: Scalars['String'];
  tagValue: Scalars['String'];
};

export type DateRangeParametersInput = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DateSearchParametersInput = {
  hours?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<DateRangeParametersInput>;
};

export type DelayWindow = {
  __typename?: 'DelayWindow';
  afterHours: Scalars['Boolean'];
  endTime: Scalars['String'];
  startTime: Scalars['String'];
  windowType: WarningEventType;
};

export type DistrictGroupSearchResult = {
  __typename?: 'DistrictGroupSearchResult';
  districtId: Scalars['ID'];
  districtName: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
};

export type DistrictInfo = {
  __typename?: 'DistrictInfo';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type DistrictSchoolGuidance = {
  __typename?: 'DistrictSchoolGuidance';
  context?: Maybe<Scalars['AWSJSON']>;
  districtId?: Maybe<Scalars['ID']>;
  endDate?: Maybe<Scalars['AWSDateTime']>;
  groupId?: Maybe<Scalars['ID']>;
  guidance: Scalars['String'];
  guidanceType: DistrictSchoolGuidanceType;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['AWSDateTime']>;
};

export type DistrictSchoolGuidanceInput = {
  context?: InputMaybe<Scalars['AWSJSON']>;
  districtId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['AWSDateTime']>;
  groupId?: InputMaybe<Scalars['ID']>;
  guidance: Scalars['String'];
  guidanceType: DistrictSchoolGuidanceType;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']>;
};

export enum DistrictSchoolGuidanceType {
  Call = 'CALL',
  ContentCategory = 'CONTENT_CATEGORY',
  Email = 'EMAIL',
  General = 'GENERAL',
  Ncmec = 'NCMEC',
  Text = 'TEXT'
}

export type DownloadLinkInfo = {
  __typename?: 'DownloadLinkInfo';
  compressed?: Maybe<Scalars['Boolean']>;
  expiration?: Maybe<Scalars['AWSTimestamp']>;
  file_size: Scalars['Int'];
  item_type: Scalars['String'];
  url: Scalars['String'];
};

export type EmailRecipient = {
  __typename?: 'EmailRecipient';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EmailRecipientInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  afterHours?: Maybe<Scalars['Boolean']>;
  alternateEmail?: Maybe<Scalars['String']>;
  currentlyAvailable: Scalars['Boolean'];
  dispatch?: Maybe<Scalars['Boolean']>;
  districtContact: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  emailAvailabilityRestricted: Scalars['Boolean'];
  emailOnly: Scalars['Boolean'];
  homePhone?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mobilePhone?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  officePhone?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  sendSMSforPSS: Scalars['Boolean'];
  subscriptions?: Maybe<EmergencyContactSubscriptions>;
  title?: Maybe<Scalars['String']>;
  unformattedHomePhone?: Maybe<PhoneNumber>;
  unformattedMobilePhone?: Maybe<PhoneNumber>;
  unformattedOfficePhone?: Maybe<PhoneNumber>;
  warningTypes?: Maybe<Array<WarningEventType>>;
};

export type EmergencyContactAvailability = {
  __typename?: 'EmergencyContactAvailability';
  categories?: Maybe<Array<InappropriateContentReason>>;
  digest: Scalars['Boolean'];
  email: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  text: Scalars['Boolean'];
};

export type EmergencyContactSubscription = {
  __typename?: 'EmergencyContactSubscription';
  categories: Array<InappropriateContentReason>;
  workItemTypes?: Maybe<Array<Maybe<WorkItemEntityType>>>;
};

export type EmergencyContactSubscriptions = {
  __typename?: 'EmergencyContactSubscriptions';
  pss?: Maybe<EmergencyContactSubscription>;
  qcon?: Maybe<EmergencyContactSubscription>;
  viol?: Maybe<EmergencyContactViolationSubscription>;
};

export type EmergencyContactViolationSubscription = {
  __typename?: 'EmergencyContactViolationSubscription';
  categories: Array<InappropriateContentReason>;
  level?: Maybe<Scalars['Int']>;
  workItemTypes?: Maybe<Array<Maybe<WorkItemEntityType>>>;
};

export type EmergencyContactWithAvailability = {
  __typename?: 'EmergencyContactWithAvailability';
  afterHours?: Maybe<Scalars['Boolean']>;
  alternateEmail?: Maybe<Scalars['String']>;
  alternatePhone?: Maybe<Scalars['String']>;
  dispatch?: Maybe<Scalars['Boolean']>;
  districtContact: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  emailOnly?: Maybe<Scalars['Boolean']>;
  firstWarning: EmergencyContactAvailability;
  homePhone?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mobilePhone?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  officePhone?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  pss: EmergencyContactAvailability;
  qcon: EmergencyContactAvailability;
  secondWarning: EmergencyContactAvailability;
  thirdWarning: EmergencyContactAvailability;
  title?: Maybe<Scalars['String']>;
  unformattedAlternatePhone?: Maybe<PhoneNumber>;
  unformattedHomePhone?: Maybe<PhoneNumber>;
  unformattedMobilePhone?: Maybe<PhoneNumber>;
  unformattedOfficePhone?: Maybe<PhoneNumber>;
};

export type Empty = {
  __typename?: 'Empty';
  success?: Maybe<Scalars['Boolean']>;
};

export enum Environment {
  Integration = 'INTEGRATION',
  Local = 'LOCAL',
  Production = 'PRODUCTION',
  Staging = 'STAGING'
}

export enum EventAction {
  Delete = 'DELETE',
  DeleteIncidentExists = 'DELETE_INCIDENT_EXISTS',
  Escalate = 'ESCALATE',
  Escalatepss = 'ESCALATEPSS',
  L1Queue = 'L1_QUEUE',
  Quarantine = 'QUARANTINE',
  QuarantineOnly = 'QUARANTINE_ONLY',
  Requestreview = 'REQUESTREVIEW',
  Resolved = 'RESOLVED',
  ResolvedIncidentExists = 'RESOLVED_INCIDENT_EXISTS',
  Unblock = 'UNBLOCK',
  Warn = 'WARN'
}

export type EventPayload = {
  __typename?: 'EventPayload';
  actionReasons?: Maybe<Array<InappropriateContentReason>>;
  allowBeta?: Maybe<Scalars['Boolean']>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  attributes?: Maybe<Scalars['AWSJSON']>;
  baseUrl?: Maybe<Scalars['String']>;
  ccRecipients?: Maybe<Array<EmailRecipient>>;
  customerId?: Maybe<Scalars['ID']>;
  customerName?: Maybe<Scalars['String']>;
  districtId?: Maybe<Scalars['ID']>;
  districtName?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['ID']>;
  emailBody?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<EmailRecipient>;
  emailSubject?: Maybe<Scalars['String']>;
  emergency?: Maybe<Scalars['Boolean']>;
  entityId?: Maybe<Scalars['String']>;
  entityOwnerId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<WorkItemEntityType>;
  fileOwnerEmail?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  itemID?: Maybe<Scalars['String']>;
  mobileRecipients?: Maybe<Array<MobileRecipient>>;
  notes?: Maybe<Scalars['String']>;
  recipients?: Maybe<Array<EmailRecipient>>;
  remoteEntityId?: Maybe<Scalars['String']>;
  safetyRepName?: Maybe<Scalars['String']>;
  templateExtraData?: Maybe<Scalars['AWSJSON']>;
  userEmail?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  warningType?: Maybe<WarningEventType>;
  workerId?: Maybe<Scalars['ID']>;
};

export type EventPayloadInput = {
  actionReasons?: InputMaybe<Array<InappropriateContentReason>>;
  allowBeta?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<AttachmentInfoInput>>;
  attributes?: InputMaybe<Scalars['AWSJSON']>;
  baseUrl?: InputMaybe<Scalars['String']>;
  ccRecipients?: InputMaybe<Array<EmailRecipientInput>>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerName?: InputMaybe<Scalars['String']>;
  districtId?: InputMaybe<Scalars['ID']>;
  districtName?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['ID']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<EmailRecipientInput>;
  emailSubject?: InputMaybe<Scalars['String']>;
  emergency?: InputMaybe<Scalars['Boolean']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityOwnerId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<WorkItemEntityType>;
  fileOwnerEmail?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  groupName?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  itemID?: InputMaybe<Scalars['String']>;
  mobileRecipients?: InputMaybe<Array<MobileRecipientInput>>;
  notes?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<Array<EmailRecipientInput>>;
  remoteEntityId?: InputMaybe<Scalars['String']>;
  safetyRepName?: InputMaybe<Scalars['String']>;
  templateExtraData?: InputMaybe<Scalars['AWSJSON']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  warningType?: InputMaybe<WarningEventType>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export type EventResult = {
  __typename?: 'EventResult';
  gsmId?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ExternalWorkItemContent = {
  __typename?: 'ExternalWorkItemContent';
  entityType?: Maybe<Scalars['String']>;
  fileContent?: Maybe<Array<Maybe<AttachmentInfo>>>;
  id: Scalars['Int'];
  textContent?: Maybe<Array<Maybe<ExternalWorkItemTextContent>>>;
  title?: Maybe<Scalars['String']>;
  updateDate?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ExternalWorkItemMetadata = {
  __typename?: 'ExternalWorkItemMetadata';
  author?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Maybe<ExternalWorkItemContent>>>;
  customerShortId: Scalars['Int'];
  externalType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  otherInfo?: Maybe<Scalars['String']>;
  participants?: Maybe<Scalars['String']>;
  requestDate?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ExternalWorkItemTextContent = {
  __typename?: 'ExternalWorkItemTextContent';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  configuration?: Maybe<Scalars['AWSJSON']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type FileComment = {
  __typename?: 'FileComment';
  anchor?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  replies?: Maybe<Array<Maybe<FileCommentReply>>>;
  timestamp?: Maybe<Scalars['Int']>;
};

export type FileCommentBlockedItem = {
  __typename?: 'FileCommentBlockedItem';
  author?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type FileCommentContent = {
  __typename?: 'FileCommentContent';
  blockedItem?: Maybe<FileCommentBlockedItem>;
  comments?: Maybe<Array<Maybe<FileComment>>>;
  documentId?: Maybe<Scalars['String']>;
  externalType?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
};

export type FileCommentReply = {
  __typename?: 'FileCommentReply';
  author?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  replyNumber?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['Int']>;
};

export type FileDetails = {
  __typename?: 'FileDetails';
  download_info?: Maybe<DownloadLinkInfo>;
  message_details?: Maybe<MessageInfo>;
};

export type GenericWorkItem = WorkItem & {
  __typename?: 'GenericWorkItem';
  apsIds?: Maybe<Array<Scalars['ID']>>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  blockReasons?: Maybe<Array<BlockReason>>;
  blockedUserId?: Maybe<Scalars['ID']>;
  bundleDigest?: Maybe<Scalars['String']>;
  bundled?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  customerId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  districtId: Scalars['ID'];
  districtIdShort?: Maybe<Scalars['String']>;
  districtInfo?: Maybe<DistrictInfo>;
  districtName?: Maybe<Scalars['String']>;
  districtNotes?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  events?: Maybe<Array<WorkItemEventRecord>>;
  extraInfo?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupIdShort?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  gsmEmailSetting?: Maybe<GsmEmailSetting>;
  id: Scalars['ID'];
  imageCacheIds?: Maybe<Array<Scalars['String']>>;
  inappropriateContentReasons?: Maybe<Array<InappropriateContentReason>>;
  incidentIds?: Maybe<Array<Scalars['ID']>>;
  itemData?: Maybe<Scalars['AWSJSON']>;
  logicalLocationId?: Maybe<Scalars['ID']>;
  ncmecId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  occurrenceDate?: Maybe<Scalars['String']>;
  safetyAudit?: Maybe<Scalars['Boolean']>;
  safetyRepId?: Maybe<Scalars['ID']>;
  studentInfo?: Maybe<StudentInfo>;
  studentTimezone?: Maybe<Scalars['String']>;
  unbundled?: Maybe<Scalars['Boolean']>;
  userEmail?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userIdShort?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  workItemEntityType: WorkItemEntityType;
  workItemSource?: Maybe<WorkItemSource>;
  workItemStatus?: Maybe<WorkItemStatus>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export type GetObjectResponse = {
  __typename?: 'GetObjectResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export enum GsmEmailSetting {
  Administrator = 'ADMINISTRATOR',
  AdministratorAndStudent = 'ADMINISTRATOR_AND_STUDENT',
  None = 'NONE',
  Student = 'STUDENT'
}

export type GsmSearchSort = {
  __typename?: 'GsmSearchSort';
  asc?: Maybe<Scalars['Boolean']>;
  field?: Maybe<Scalars['String']>;
};

export type ImportLegacyInstructionsResult = {
  __typename?: 'ImportLegacyInstructionsResult';
  message?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type ImportTbdTemplateResult = {
  __typename?: 'ImportTBDTemplateResult';
  message?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export enum InappropriateContentReason {
  DrugUse = 'DRUG_USE',
  FalsePositive = 'FALSE_POSITIVE',
  General = 'GENERAL',
  Harassment = 'HARASSMENT',
  Nudity = 'NUDITY',
  Profanity = 'PROFANITY',
  RestrictedUse = 'RESTRICTED_USE',
  SelfHarm = 'SELF_HARM',
  SexualContent = 'SEXUAL_CONTENT',
  SpamBulk = 'SPAM_BULK',
  Suicide = 'SUICIDE',
  UnableToProcess = 'UNABLE_TO_PROCESS',
  ViolenceOthers = 'VIOLENCE_OTHERS',
  /** @deprecated Field no longer supported */
  ViolenceSelf = 'VIOLENCE_SELF',
  OtherTbd = '_OTHER_TBD'
}

export type InappropriateContentReasonsResponse = {
  __typename?: 'InappropriateContentReasonsResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Incident = {
  __typename?: 'Incident';
  acknowledgmentDetails?: Maybe<AcknowledgmentDetails>;
  actionReasons?: Maybe<Array<InappropriateContentReason>>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  blockedReasons?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<IncidentCommentRecord>>;
  contentLinkBaseUrl?: Maybe<Scalars['String']>;
  contentLinkTitles?: Maybe<Scalars['String']>;
  customerId: Scalars['ID'];
  customerName?: Maybe<Scalars['String']>;
  deletedByUserid?: Maybe<Scalars['ID']>;
  deletedDate?: Maybe<Scalars['String']>;
  deletedIpaddress?: Maybe<Scalars['String']>;
  districtId: Scalars['ID'];
  districtName?: Maybe<Scalars['String']>;
  emergencyContactId?: Maybe<Scalars['Int']>;
  emergencyContactName?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType: WorkItemEntityType;
  events?: Maybe<Array<IncidentEventRecord>>;
  gaft?: Maybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  groupName?: Maybe<Scalars['String']>;
  incidentEmail?: Maybe<IncidentEmail>;
  incidentId: Scalars['ID'];
  internalNotes?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  occurrenceDate: Scalars['String'];
  processedDate: Scalars['String'];
  resolutionType?: Maybe<ResolutionType>;
  resolvedByUserid?: Maybe<Scalars['ID']>;
  resolvedDate?: Maybe<Scalars['String']>;
  resolvedIpaddress?: Maybe<Scalars['String']>;
  safetyRepName?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userName?: Maybe<Scalars['String']>;
  warningType: WarningEventType;
  workItemId: Scalars['ID'];
  workItemStatus?: Maybe<WorkItemStatus>;
  workerCommunications?: Maybe<IncidentWorkerEmergencyContactsCommunications>;
  workerId: Scalars['ID'];
};

export type IncidentAcknowledgment = {
  __typename?: 'IncidentAcknowledgment';
  fullName?: Maybe<Scalars['String']>;
  incidentId?: Maybe<Scalars['ID']>;
  source?: Maybe<AcknowledgmentSource>;
  userId?: Maybe<Scalars['ID']>;
  workItemId?: Maybe<Scalars['ID']>;
};

export type IncidentApiSearchResponse = {
  __typename?: 'IncidentApiSearchResponse';
  incidents?: Maybe<Array<Incident>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  query?: Maybe<Scalars['AWSJSON']>;
  total: Scalars['Int'];
};

export type IncidentCommentRecord = {
  __typename?: 'IncidentCommentRecord';
  commentBody: Scalars['String'];
  commentDate?: Maybe<Scalars['String']>;
  userUuid: Scalars['ID'];
};

export type IncidentEmail = {
  __typename?: 'IncidentEmail';
  bodyHtml?: Maybe<Scalars['String']>;
  bodyText?: Maybe<Scalars['String']>;
  cc?: Maybe<Array<Scalars['String']>>;
  from: Scalars['String'];
  subject: Scalars['String'];
  to?: Maybe<Array<Scalars['String']>>;
};

export type IncidentEventRecord = {
  __typename?: 'IncidentEventRecord';
  date?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export type IncidentSearchParametersInput = {
  contentCategories?: InputMaybe<Array<InappropriateContentReason>>;
  districtId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  incidentTypes?: InputMaybe<Array<IncidentType>>;
  keyword?: InputMaybe<Scalars['String']>;
  occurrenceDate?: InputMaybe<DateSearchParametersInput>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  processedDate?: InputMaybe<DateSearchParametersInput>;
  sort: IncidentSearchSortInput;
  userId?: InputMaybe<Scalars['ID']>;
  userIdShort?: InputMaybe<Scalars['Int']>;
  workItemTypes?: InputMaybe<Array<WorkItemEntityType>>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export enum IncidentSearchSortField {
  EntityType = 'ENTITY_TYPE',
  OccurrenceDate = 'OCCURRENCE_DATE',
  ProcessedDate = 'PROCESSED_DATE',
  Status = 'STATUS',
  WarningType = 'WARNING_TYPE'
}

export type IncidentSearchSortInput = {
  fieldName: IncidentSearchSortField;
  order: SortOrder;
};

export enum IncidentType {
  Pss = 'PSS',
  Qcon = 'QCON',
  Viol = 'VIOL'
}

export type IncidentWorkerEmergencyContactStatus = {
  __typename?: 'IncidentWorkerEmergencyContactStatus';
  afterHours?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<WorkerEmergencyContactCommunicationsAvailability>;
  communications?: Maybe<WorkerEmergencyContactCommunicationsStatus>;
  dispatch?: Maybe<Scalars['Boolean']>;
  districtContact?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type IncidentWorkerEmergencyContactStatusInput = {
  afterHours?: InputMaybe<Scalars['Boolean']>;
  availability?: InputMaybe<WorkerEmergencyContactCommunicationsAvailabilityInput>;
  communications?: InputMaybe<WorkerEmergencyContactCommunicationsStatusInput>;
  dispatch?: InputMaybe<Scalars['Boolean']>;
  districtContact?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IncidentWorkerEmergencyContactsCommunications = {
  __typename?: 'IncidentWorkerEmergencyContactsCommunications';
  afterHours?: Maybe<Scalars['Boolean']>;
  contacts?: Maybe<Array<IncidentWorkerEmergencyContactStatus>>;
  date?: Maybe<Scalars['String']>;
};

export type IncidentWorkerEmergencyContactsCommunicationsInput = {
  afterHours?: InputMaybe<Scalars['Boolean']>;
  contacts?: InputMaybe<Array<IncidentWorkerEmergencyContactStatusInput>>;
  date?: InputMaybe<Scalars['String']>;
};

export type KmmEventInput = {
  blockReasons?: InputMaybe<Array<InputMaybe<BlockReasonInput>>>;
  durationOfDisposition?: InputMaybe<Scalars['Int']>;
  eventDate: Scalars['AWSDateTime'];
  eventDetails?: InputMaybe<Array<InputMaybe<KmmEventDetail>>>;
  eventName: L1EventType;
  imageCacheIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mouseClickEvent?: InputMaybe<Scalars['Boolean']>;
  workItemId: Scalars['String'];
  workerId: Scalars['String'];
};

export type KmmEventDetail = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type L1DebugEventInput = {
  debugInfo: Scalars['AWSJSON'];
  debugReason?: InputMaybe<Scalars['String']>;
  workItemId: Scalars['String'];
  workerUsername: Scalars['String'];
};

export enum L1EventType {
  Delete = 'DELETE',
  Escalate = 'ESCALATE',
  Unblock = 'UNBLOCK'
}

export enum LoggingLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum LoggingSource {
  L1Ui = 'L1UI',
  L2Ui = 'L2UI'
}

export type LogicalQueueRequest = {
  __typename?: 'LogicalQueueRequest';
  attributes?: Maybe<Scalars['AWSJSON']>;
  name: Scalars['String'];
};

export type LogicalQueueRequestInput = {
  attributes?: InputMaybe<Scalars['AWSJSON']>;
  name: Scalars['String'];
};

export type MessageInfo = {
  __typename?: 'MessageInfo';
  attachments?: Maybe<Array<AttachmentInfo>>;
  content?: Maybe<Array<Scalars['String']>>;
  content_type?: Maybe<Scalars['String']>;
  recipients: Scalars['String'];
  sender: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
};

export type MessageMetadata = {
  __typename?: 'MessageMetadata';
  attachments?: Maybe<Array<AttachmentInfo>>;
  chat_context?: Maybe<Scalars['AWSJSON']>;
  content?: Maybe<Array<Scalars['String']>>;
  content_type?: Maybe<Scalars['String']>;
  download_info?: Maybe<DownloadLinkInfo>;
  recipients?: Maybe<Scalars['String']>;
  sender: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
};

export type MobileRecipient = {
  __typename?: 'MobileRecipient';
  deviceNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type MobileRecipientInput = {
  deviceNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeIncident: Empty;
  acknowledgeSMS?: Maybe<Array<Maybe<SmsStatus>>>;
  addApplicationUser?: Maybe<ApplicationUser>;
  cancelIncidentAcknowledgedSubscription?: Maybe<Empty>;
  captureDatadogMetric: Empty;
  captureKmmEvent: Empty;
  changeItemVisibilityTimeout: Empty;
  completeGSMProcessing?: Maybe<Empty>;
  createDistrictSchoolGuidance?: Maybe<CreateDistrictSchoolGuidanceResult>;
  createSalesforceCase?: Maybe<SalesforceCaseResponse>;
  debugL1WorkItem: Empty;
  deleteApplicationUser?: Maybe<ApplicationUser>;
  deleteDistrictSchoolGuidance?: Maybe<DistrictSchoolGuidance>;
  deleteSMSTemplate: SmsTemplate;
  importLegacyDistrictInstructions?: Maybe<ImportLegacyInstructionsResult>;
  importTBDTemplates?: Maybe<ImportTbdTemplateResult>;
  importUsers?: Maybe<Array<Maybe<Scalars['String']>>>;
  logEvent: Empty;
  logout: Empty;
  newEvent: EventResult;
  notifyIncidentAcknowledgment: IncidentAcknowledgment;
  processSMSCallback?: Maybe<Empty>;
  resendIncidentEmail: Empty;
  saveSMSTemplate: SmsTemplate;
  saveWorkerCommunications?: Maybe<Incident>;
  sendSMS?: Maybe<Array<Maybe<SmsStatus>>>;
  sendUIAnalyticsEvent?: Maybe<Empty>;
  simpleNewEvent: EventResult;
  submitNCMECReport: NcmecReportResults;
  submitNCMECSafetyAuditReports: Empty;
  updateApplicationUser?: Maybe<ApplicationUser>;
  updateDistrictSchoolGuidance?: Maybe<DistrictSchoolGuidance>;
  updateSMSStatus?: Maybe<SmsStatus>;
};


export type MutationAcknowledgeIncidentArgs = {
  fullName: Scalars['String'];
  incidentId: Scalars['ID'];
  source?: InputMaybe<AcknowledgmentSource>;
  userId: Scalars['ID'];
  workItemId?: InputMaybe<Scalars['ID']>;
};


export type MutationAcknowledgeSmsArgs = {
  fullName: Scalars['String'];
  gsmId: Scalars['ID'];
  incidentId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddApplicationUserArgs = {
  user: ApplicationUserInput;
};


export type MutationCancelIncidentAcknowledgedSubscriptionArgs = {
  workItemId: Scalars['ID'];
};


export type MutationCaptureDatadogMetricArgs = {
  metricEvent: DatadogMetricInput;
};


export type MutationCaptureKmmEventArgs = {
  kmmEvent: KmmEventInput;
};


export type MutationChangeItemVisibilityTimeoutArgs = {
  itemId: Scalars['ID'];
  timeoutSecs: Scalars['Int'];
};


export type MutationCompleteGsmProcessingArgs = {
  workItemId: Scalars['ID'];
};


export type MutationCreateDistrictSchoolGuidanceArgs = {
  districtId: Scalars['ID'];
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  guidance: DistrictSchoolGuidanceInput;
};


export type MutationCreateSalesforceCaseArgs = {
  description?: InputMaybe<Scalars['String']>;
  emergencyContactId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<SalesforceCaseStatus>;
  subject?: InputMaybe<Scalars['String']>;
  workItemId: Scalars['ID'];
};


export type MutationDebugL1WorkItemArgs = {
  l1DebugEvent: L1DebugEventInput;
};


export type MutationDeleteApplicationUserArgs = {
  userId: Scalars['ID'];
};


export type MutationDeleteDistrictSchoolGuidanceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSmsTemplateArgs = {
  id: Scalars['ID'];
  warningType: WarningEventType;
};


export type MutationImportUsersArgs = {
  userPoolId: Scalars['String'];
};


export type MutationLogEventArgs = {
  data?: InputMaybe<Scalars['AWSJSON']>;
  level: LoggingLevel;
  message: Scalars['String'];
  source: LoggingSource;
};


export type MutationLogoutArgs = {
  refreshToken: Scalars['String'];
  userPoolClientId: Scalars['String'];
};


export type MutationNewEventArgs = {
  request: WorkItemEventInput;
};


export type MutationNotifyIncidentAcknowledgmentArgs = {
  fullName: Scalars['String'];
  incidentId: Scalars['ID'];
  source: AcknowledgmentSource;
  userId: Scalars['ID'];
  workItemId: Scalars['ID'];
};


export type MutationProcessSmsCallbackArgs = {
  rawBody: Scalars['String'];
  signature: Scalars['String'];
  url: Scalars['String'];
};


export type MutationResendIncidentEmailArgs = {
  incidentId: Scalars['ID'];
  messageBody: Scalars['String'];
  recipients: Array<EmailRecipientInput>;
};


export type MutationSaveSmsTemplateArgs = {
  template: SmsTemplateInput;
};


export type MutationSaveWorkerCommunicationsArgs = {
  communications: IncidentWorkerEmergencyContactsCommunicationsInput;
  incidentId: Scalars['ID'];
};


export type MutationSendSmsArgs = {
  body: Scalars['String'];
  gsmId: Scalars['ID'];
  isAcknowledged?: InputMaybe<Scalars['Boolean']>;
  recipients: Array<SmsEmergencyContactInput>;
  schedule?: InputMaybe<SmsSchedule>;
};


export type MutationSendUiAnalyticsEventArgs = {
  action: UiEventAction;
  application: UiApplication;
  eventDateTime?: InputMaybe<Scalars['AWSDateTime']>;
  isHighPriority: Scalars['Boolean'];
  queue: UiQueue;
  startDateTime: Scalars['AWSDateTime'];
  workItemId: Scalars['ID'];
};


export type MutationSimpleNewEventArgs = {
  request: WorkItemEventInput;
};


export type MutationSubmitNcmecReportArgs = {
  classification?: InputMaybe<NcmecIndustryClassification>;
  districtOverrides?: InputMaybe<NcmecDistrictOverridesInput>;
  incidentTimestamp: Scalars['String'];
  incidentTimezone: Scalars['String'];
  request: WorkItemEventInput;
  safetyAudit: Scalars['Boolean'];
  schoolOverrides?: InputMaybe<NcmecSchoolOverridesInput>;
  studentOverrides?: InputMaybe<NcmecStudentOverridesInput>;
};


export type MutationSubmitNcmecSafetyAuditReportsArgs = {
  customerId: Scalars['ID'];
};


export type MutationUpdateApplicationUserArgs = {
  user: ApplicationUserInput;
  userId: Scalars['ID'];
};


export type MutationUpdateDistrictSchoolGuidanceArgs = {
  guidance: DistrictSchoolGuidanceInput;
};


export type MutationUpdateSmsStatusArgs = {
  contactId: Scalars['ID'];
  failureCode?: InputMaybe<Scalars['String']>;
  failureMessage?: InputMaybe<Scalars['String']>;
  gsmId: Scalars['ID'];
  messageId: Scalars['String'];
  reply?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type NcmecDistrictOverridesInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export enum NcmecIndustryClassification {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2'
}

export type NcmecReportResult = {
  __typename?: 'NCMECReportResult';
  incidentTimestamp?: Maybe<Scalars['String']>;
  ncmecLog?: Maybe<Scalars['AWSJSON']>;
  reportId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workItemId?: Maybe<Scalars['String']>;
};

export type NcmecReportResults = {
  __typename?: 'NCMECReportResults';
  customerId?: Maybe<Scalars['String']>;
  reports?: Maybe<Array<Maybe<NcmecReportResult>>>;
};

export type NcmecSchoolOverridesInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type NcmecStudentOverridesInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type NextWorkItemRequestInput = {
  numberOfItems: Scalars['Int'];
  request: Array<TypeRequestInput>;
  typePriority: TypePriority;
  visibilityTimeoutSeconds?: InputMaybe<Scalars['Int']>;
  workerId: Scalars['ID'];
};

export type NextWorkItemResponse = {
  __typename?: 'NextWorkItemResponse';
  items: Array<WorkItem>;
};

export type PsapAddressInfo = {
  __typename?: 'PSAPAddressInfo';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type PsapContact = {
  __typename?: 'PSAPContact';
  address?: Maybe<PsapAddressInfo>;
  psaps?: Maybe<Array<Maybe<PsapData>>>;
  relationship?: Maybe<Scalars['String']>;
};

export type PsapData = {
  __typename?: 'PSAPData';
  address?: Maybe<PsapAddressInfo>;
  mapUrl?: Maybe<Scalars['String']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  areaCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type PhoneNumberInput = {
  areaCode: Scalars['String'];
  countryCode: Scalars['String'];
  ext?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  availableLanguages?: Maybe<Scalars['AWSJSON']>;
  downloadLink?: Maybe<DownloadLinkInfo>;
  /** @deprecated Superseded by 'getEmergencyContacts' */
  emergencyContacts?: Maybe<Array<Maybe<EmergencyContact>>>;
  getApplicationUser?: Maybe<ApplicationUser>;
  getApplicationUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  getDistrictSchoolGuidance?: Maybe<Array<Maybe<DistrictSchoolGuidance>>>;
  getEmergencyContacts?: Maybe<Array<EmergencyContactWithAvailability>>;
  getExternalWorkItemMetadata?: Maybe<ExternalWorkItemMetadata>;
  getFeatureFlags?: Maybe<Array<FeatureFlag>>;
  getFileComments?: Maybe<FileCommentContent>;
  getGSMContactSMSStatus?: Maybe<Array<Maybe<SmsStatus>>>;
  getLegacyDistrictNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  getMessageMetadata?: Maybe<MessageMetadata>;
  getPSAPInfoForStudent?: Maybe<Array<Maybe<PsapContact>>>;
  getPriorIncidents?: Maybe<IncidentApiSearchResponse>;
  getQCONPSSDelayWindows?: Maybe<Array<DelayWindow>>;
  getSMSTemplates?: Maybe<Array<SmsTemplate>>;
  getTbdTemplates?: Maybe<Array<TbdTemplate>>;
  getWorkItem?: Maybe<WorkItem>;
  /** @deprecated Superseded by 'getWorkItemAndIncidentByGsmId' */
  getWorkItemAndIncident?: Maybe<WorkItemWithIncident>;
  getWorkItemAndIncidentByGsmId?: Maybe<WorkItemWithIncident>;
  getWorkItemFeatureFlags?: Maybe<Array<FeatureFlag>>;
  getWorkItemStatus?: Maybe<WorkItemStateMachineStatus>;
  nextL1WorkItemBatch?: Maybe<Array<Maybe<WorkItem>>>;
  nextWorkItem?: Maybe<WorkItem>;
  queueStatistics?: Maybe<QueueStatisticsList>;
  refreshAttachmentPresignedUrl?: Maybe<Scalars['String']>;
  searchDistrictsAndGroups?: Maybe<Array<Maybe<DistrictGroupSearchResult>>>;
  searchGSMWorkers?: Maybe<Array<Maybe<WorkerSearchResult>>>;
  searchIncidents?: Maybe<IncidentApiSearchResponse>;
  searchUserByDistrictAndGroup?: Maybe<Array<Maybe<UserSearchResult>>>;
  searchWorkItems?: Maybe<WorkItemSearchResponse>;
  simpleNextWorkItem?: Maybe<WorkItem>;
  simpleQueueStatistics?: Maybe<Array<SimpleQueueStatistics>>;
  suggestedWarningLevel?: Maybe<WarningEventType>;
  translate?: Maybe<Array<Maybe<Scalars['String']>>>;
  validDownloadTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryDownloadLinkArgs = {
  customerId: Scalars['String'];
  logicalId: Scalars['String'];
  noCopy?: InputMaybe<Scalars['Boolean']>;
  targetFileName?: InputMaybe<Scalars['String']>;
  workItemType: Scalars['String'];
};


export type QueryEmergencyContactsArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  isAfterHours?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetDistrictSchoolGuidanceArgs = {
  districtId: Scalars['ID'];
  groupId?: InputMaybe<Scalars['ID']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  guidanceTypes?: InputMaybe<Array<DistrictSchoolGuidanceType>>;
};


export type QueryGetEmergencyContactsArgs = {
  districtId: Scalars['ID'];
  groupId: Scalars['ID'];
  targetDateTime?: InputMaybe<Scalars['AWSDateTime']>;
  workItemType: WorkItemEntityType;
};


export type QueryGetExternalWorkItemMetadataArgs = {
  workItemId: Scalars['ID'];
};


export type QueryGetFeatureFlagsArgs = {
  flagNames: Array<Scalars['String']>;
};


export type QueryGetFileCommentsArgs = {
  commentId: Scalars['String'];
  contextCount?: InputMaybe<Scalars['Int']>;
};


export type QueryGetGsmContactSmsStatusArgs = {
  contactId: Scalars['String'];
  isAcknowledged: Scalars['Boolean'];
};


export type QueryGetLegacyDistrictNotesArgs = {
  districtId: Scalars['ID'];
};


export type QueryGetMessageMetadataArgs = {
  customerId: Scalars['String'];
  logicalId: Scalars['String'];
  workItemType: WorkItemEntityType;
};


export type QueryGetPsapInfoForStudentArgs = {
  userId: Scalars['ID'];
};


export type QueryGetPriorIncidentsArgs = {
  userId: Scalars['String'];
};


export type QueryGetQconpssDelayWindowsArgs = {
  groupId: Scalars['ID'];
  timeZone: Scalars['String'];
};


export type QueryGetSmsTemplatesArgs = {
  warningType: WarningEventType;
};


export type QueryGetTbdTemplatesArgs = {
  workItemType: Scalars['String'];
};


export type QueryGetWorkItemArgs = {
  workItemId: Scalars['String'];
};


export type QueryGetWorkItemAndIncidentArgs = {
  workItemId: Scalars['ID'];
};


export type QueryGetWorkItemAndIncidentByGsmIdArgs = {
  gsmId: Scalars['ID'];
};


export type QueryGetWorkItemFeatureFlagsArgs = {
  flagNames: Array<Scalars['String']>;
  workItem: WorkItemFeatureFlagInput;
};


export type QueryGetWorkItemStatusArgs = {
  workItemId: Scalars['ID'];
};


export type QueryNextWorkItemArgs = {
  isL1: Scalars['Boolean'];
  pss?: InputMaybe<Scalars['Boolean']>;
  queueType?: InputMaybe<Scalars['String']>;
};


export type QueryRefreshAttachmentPresignedUrlArgs = {
  s3Key: Scalars['String'];
  workItemType: WorkItemEntityType;
};


export type QuerySearchDistrictsAndGroupsArgs = {
  byIds?: InputMaybe<Array<Scalars['ID']>>;
  searchForNameContaining?: InputMaybe<Scalars['String']>;
};


export type QuerySearchGsmWorkersArgs = {
  searchForNameContaining?: InputMaybe<Scalars['String']>;
};


export type QuerySearchIncidentsArgs = {
  searchParameters: IncidentSearchParametersInput;
};


export type QuerySearchUserByDistrictAndGroupArgs = {
  districtId: Scalars['ID'];
  groupId?: InputMaybe<Scalars['ID']>;
  searchForNameContaining?: InputMaybe<Scalars['String']>;
};


export type QuerySearchWorkItemsArgs = {
  searchParameters: WorkItemSearchParametersInput;
};


export type QuerySimpleNextWorkItemArgs = {
  queueName: Scalars['String'];
};


export type QuerySuggestedWarningLevelArgs = {
  blockedUserId: Scalars['String'];
  workItemType: WorkItemEntityType;
};


export type QueryTranslateArgs = {
  sourceLanguage?: InputMaybe<Scalars['String']>;
  targetLanguage: Scalars['String'];
  textToTranslate: Array<Scalars['String']>;
  workItemId?: InputMaybe<Scalars['ID']>;
};

export type QueueStatistics = {
  __typename?: 'QueueStatistics';
  highPriorityCount: Scalars['Int'];
  level1Count: Scalars['Int'];
  level2Count: Scalars['Int'];
  type: Scalars['String'];
};

export type QueueStatisticsList = {
  __typename?: 'QueueStatisticsList';
  queues: Array<QueueStatistics>;
};

export type QueueStatisticsRecord = QueueStatisticsSummary;

export type QueueStatisticsSummary = {
  __typename?: 'QueueStatisticsSummary';
  approximateQueueSize: Scalars['Int'];
};

export enum ResolutionType {
  NonIssue = 'NON_ISSUE',
  ThreatAddressed = 'THREAT_ADDRESSED'
}

export type SmsEmergencyContactInput = {
  id: Scalars['String'];
  mobilePhone: PhoneNumberInput;
  name: Scalars['String'];
};

export enum SmsMessageStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Received = 'RECEIVED',
  Replied = 'REPLIED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
  Unknown = 'UNKNOWN'
}

export type SmsSchedule = {
  targetDate: Scalars['String'];
  targetTime: Scalars['String'];
  timeZone: Scalars['String'];
};

export type SmsStatus = {
  __typename?: 'SMSStatus';
  body?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['ID']>;
  contactName?: Maybe<Scalars['String']>;
  failureCode?: Maybe<Scalars['String']>;
  failureMessage?: Maybe<Scalars['String']>;
  gsmId?: Maybe<Scalars['ID']>;
  messageId?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  reply?: Maybe<Scalars['String']>;
  scheduledFor?: Maybe<Scalars['String']>;
  status?: Maybe<SmsMessageStatus>;
  statusDate?: Maybe<Scalars['String']>;
};

export type SmsTemplate = {
  __typename?: 'SMSTemplate';
  afterHours: Scalars['Boolean'];
  categories: Array<InappropriateContentReason>;
  dropdownOption: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  warningType: WarningEventType;
  workItemTypes: Array<WorkItemEntityType>;
};

export type SmsTemplateInput = {
  afterHours: Scalars['Boolean'];
  categories: Array<InappropriateContentReason>;
  dropdownOption: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  message: Scalars['String'];
  warningType: WarningEventType;
  workItemTypes: Array<WorkItemEntityType>;
};

export type SalesforceCaseResponse = {
  __typename?: 'SalesforceCaseResponse';
  caseUrl?: Maybe<Scalars['AWSURL']>;
};

export enum SalesforceCaseStatus {
  ActionRequiredNoAavResponse = 'ACTION_REQUIRED_NO_AAV_RESPONSE',
  ClosedAavCancelled = 'CLOSED_AAV_CANCELLED',
  ClosedNoActionNeeded = 'CLOSED_NO_ACTION_NEEDED',
  ClosedNoResponseFromCustomer = 'CLOSED_NO_RESPONSE_FROM_CUSTOMER',
  ClosedResolved = 'CLOSED_RESOLVED',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  Pending = 'PENDING',
  ReopenedByCustomer = 'REOPENED_BY_CUSTOMER'
}

export type SimpleQueueStatistics = {
  __typename?: 'SimpleQueueStatistics';
  count: Scalars['Int'];
  logicalQueue: Scalars['String'];
};

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SpeakupWorkItem = WorkItem & {
  __typename?: 'SpeakupWorkItem';
  apsIds?: Maybe<Array<Scalars['ID']>>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  blockReasons?: Maybe<Array<BlockReason>>;
  blockedUserId?: Maybe<Scalars['ID']>;
  bundleDigest?: Maybe<Scalars['String']>;
  bundled?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  customerId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  districtId: Scalars['ID'];
  districtIdShort?: Maybe<Scalars['String']>;
  districtInfo?: Maybe<DistrictInfo>;
  districtName?: Maybe<Scalars['String']>;
  districtNotes?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  events?: Maybe<Array<WorkItemEventRecord>>;
  extraInfo?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupIdShort?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  gsmEmailSetting?: Maybe<GsmEmailSetting>;
  id: Scalars['ID'];
  imageCacheIds?: Maybe<Array<Scalars['String']>>;
  inappropriateContentReasons?: Maybe<Array<InappropriateContentReason>>;
  incidentIds?: Maybe<Array<Scalars['ID']>>;
  itemData?: Maybe<Scalars['AWSJSON']>;
  logicalLocationId?: Maybe<Scalars['ID']>;
  messageFrom?: Maybe<Scalars['String']>;
  messageTo?: Maybe<Scalars['String']>;
  ncmecId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['ID']>;
  occurrenceDate?: Maybe<Scalars['String']>;
  safetyAudit?: Maybe<Scalars['Boolean']>;
  safetyRepId?: Maybe<Scalars['ID']>;
  studentInfo?: Maybe<StudentInfo>;
  studentTimezone?: Maybe<Scalars['String']>;
  unbundled?: Maybe<Scalars['Boolean']>;
  userEmail?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userIdShort?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  workItemEntityType: WorkItemEntityType;
  workItemSource?: Maybe<WorkItemSource>;
  workItemStatus?: Maybe<WorkItemStatus>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export type StudentInfo = {
  __typename?: 'StudentInfo';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  incidentAcknowledged?: Maybe<IncidentAcknowledgment>;
  smsStatusUpdated?: Maybe<SmsStatus>;
  userUpdated?: Maybe<ApplicationUser>;
};


export type SubscriptionIncidentAcknowledgedArgs = {
  workItemId: Scalars['ID'];
};


export type SubscriptionSmsStatusUpdatedArgs = {
  contactId: Scalars['ID'];
  gsmId: Scalars['ID'];
};


export type SubscriptionUserUpdatedArgs = {
  userId: Scalars['ID'];
};

export enum SupportedType {
  Files = 'files',
  Hangout = 'hangout',
  Messages = 'messages',
  Speakup = 'speakup'
}

export type TbdTemplate = {
  __typename?: 'TbdTemplate';
  body?: Maybe<Scalars['String']>;
  category?: Maybe<InappropriateContentReason>;
  dropdownOption?: Maybe<Scalars['String']>;
  featureFlagCondition?: Maybe<Scalars['String']>;
  forMultipleItemsOnly?: Maybe<Scalars['Boolean']>;
  forQuarantineItemsOnly?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  warningType?: Maybe<WarningEventType>;
  workItemType?: Maybe<WorkItemEntityType>;
};

export type ThirdPartyWorkItem = WorkItem & {
  __typename?: 'ThirdPartyWorkItem';
  apsIds?: Maybe<Array<Scalars['ID']>>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  blockReasons?: Maybe<Array<BlockReason>>;
  blockedUserId?: Maybe<Scalars['ID']>;
  bundleDigest?: Maybe<Scalars['String']>;
  bundled?: Maybe<Scalars['Boolean']>;
  canQuarantine?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  customerId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  districtId: Scalars['ID'];
  districtIdShort?: Maybe<Scalars['String']>;
  districtInfo?: Maybe<DistrictInfo>;
  districtName?: Maybe<Scalars['String']>;
  districtNotes?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entitySize?: Maybe<Scalars['Int']>;
  events?: Maybe<Array<WorkItemEventRecord>>;
  extraInfo?: Maybe<Scalars['String']>;
  fileOwnerEmail?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  groupIdShort?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  gsmEmailSetting?: Maybe<GsmEmailSetting>;
  id: Scalars['ID'];
  imageCacheIds?: Maybe<Array<Scalars['String']>>;
  inappropriateContentReasons?: Maybe<Array<InappropriateContentReason>>;
  incidentIds?: Maybe<Array<Scalars['ID']>>;
  itemData?: Maybe<Scalars['AWSJSON']>;
  lastModified?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  logicalLocationId?: Maybe<Scalars['ID']>;
  ncmecId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  occurrenceDate?: Maybe<Scalars['String']>;
  remoteEntityId?: Maybe<Scalars['String']>;
  remoteOwnerId?: Maybe<Scalars['ID']>;
  revision?: Maybe<Scalars['Int']>;
  safetyAudit?: Maybe<Scalars['Boolean']>;
  safetyRepId?: Maybe<Scalars['ID']>;
  sharedToUser?: Maybe<Scalars['Boolean']>;
  studentInfo?: Maybe<StudentInfo>;
  studentTimezone?: Maybe<Scalars['String']>;
  unbundled?: Maybe<Scalars['Boolean']>;
  userEmail?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userIdShort?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  workItemEntityType: WorkItemEntityType;
  workItemSource?: Maybe<WorkItemSource>;
  workItemStatus?: Maybe<WorkItemStatus>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export type TranslationRequest = {
  __typename?: 'TranslationRequest';
  targetLanguage: Scalars['String'];
  textToTranslate: Array<Scalars['String']>;
  workItemId?: Maybe<Scalars['ID']>;
};

export type TranslationRequestInput = {
  targetLanguage: Scalars['String'];
  textToTranslate: Array<Scalars['String']>;
  workItemId?: InputMaybe<Scalars['ID']>;
};

export enum TypePriority {
  Ordered = 'ORDERED'
}

export type TypeRequest = {
  __typename?: 'TypeRequest';
  logicalQueues: Array<LogicalQueueRequest>;
  workItemEntityType?: Maybe<WorkItemEntityType>;
};

export type TypeRequestInput = {
  logicalQueues: Array<LogicalQueueRequestInput>;
  workItemEntityType?: InputMaybe<WorkItemEntityType>;
};

export enum UiApplication {
  L1Ui = 'L1UI',
  L2Ui = 'L2UI'
}

export enum UiEventAction {
  ActiveWorkerRefresh = 'ACTIVE_WORKER_REFRESH',
  CallEmergencyContact = 'CALL_EMERGENCY_CONTACT',
  CallSectionOpened = 'CALL_SECTION_OPENED',
  CancelIncidentCreation = 'CANCEL_INCIDENT_CREATION',
  CopyDistrictName = 'COPY_DISTRICT_NAME',
  CopyGroupName = 'COPY_GROUP_NAME',
  CopyItemId = 'COPY_ITEM_ID',
  CopyStudentId = 'COPY_STUDENT_ID',
  CreatePss = 'CREATE_PSS',
  CreateQcon = 'CREATE_QCON',
  CreateSalesforceCase = 'CREATE_SALESFORCE_CASE',
  CreateViolation = 'CREATE_VIOLATION',
  Delete = 'DELETE',
  DeleteNcmec = 'DELETE_NCMEC',
  DeletePriorIncident = 'DELETE_PRIOR_INCIDENT',
  DownloadContent = 'DOWNLOAD_CONTENT',
  Escalate = 'ESCALATE',
  EscalatePss = 'ESCALATE_PSS',
  Exit = 'EXIT',
  InactiveWorkerRefresh = 'INACTIVE_WORKER_REFRESH',
  InactiveWorkerSkip = 'INACTIVE_WORKER_SKIP',
  NcmecSectionOpened = 'NCMEC_SECTION_OPENED',
  PriorIncidentsLinkSelected = 'PRIOR_INCIDENTS_LINK_SELECTED',
  QuarantineOnlyNcmec = 'QUARANTINE_ONLY_NCMEC',
  QuarantineOnlyNoPriors = 'QUARANTINE_ONLY_NO_PRIORS',
  RequestReview = 'REQUEST_REVIEW',
  ResolveItem = 'RESOLVE_ITEM',
  ResolveItemNcmec = 'RESOLVE_ITEM_NCMEC',
  ResolveItemPriorIncident = 'RESOLVE_ITEM_PRIOR_INCIDENT',
  SendNcmecReport = 'SEND_NCMEC_REPORT',
  SendTextMessages = 'SEND_TEXT_MESSAGES',
  Skip = 'SKIP',
  SmsSectionOpened = 'SMS_SECTION_OPENED',
  TranslateContent = 'TRANSLATE_CONTENT',
  Unblock = 'UNBLOCK',
  ViewStudentLinkSelected = 'VIEW_STUDENT_LINK_SELECTED',
  WorkEnded = 'WORK_ENDED',
  WorkStarted = 'WORK_STARTED'
}

export enum UiQueue {
  Escalation = 'ESCALATION',
  Standard = 'STANDARD'
}

export type UnbundleItemResponse = {
  __typename?: 'UnbundleItemResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateItemTtlResponse = {
  __typename?: 'UpdateItemTtlResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateOwnerEntityItemResponse = {
  __typename?: 'UpdateOwnerEntityItemResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export enum UserOption {
  Audit = 'audit',
  Gsm = 'gsm',
  Images = 'images',
  Pss = 'pss'
}

export enum UserPermission {
  CreatePssIncidents = 'CREATE_PSS_INCIDENTS',
  GsmQueues = 'GSM_QUEUES',
  ImageGrid = 'IMAGE_GRID',
  ImageOnlyWorkItems = 'IMAGE_ONLY_WORK_ITEMS',
  L2AuditQueues = 'L2_AUDIT_QUEUES',
  ManageDistrictSchoolCategorySettings = 'MANAGE_DISTRICT_SCHOOL_CATEGORY_SETTINGS',
  ManageDistrictSchoolNotices = 'MANAGE_DISTRICT_SCHOOL_NOTICES',
  ManageHoverGlossary = 'MANAGE_HOVER_GLOSSARY',
  ManageIncidentEmailTemplates = 'MANAGE_INCIDENT_EMAIL_TEMPLATES',
  ManageIncidentSmsTemplates = 'MANAGE_INCIDENT_SMS_TEMPLATES',
  ManageQueueFlipProcessSettings = 'MANAGE_QUEUE_FLIP_PROCESS_SETTINGS',
  ManageWorkItemGatekeeper = 'MANAGE_WORK_ITEM_GATEKEEPER',
  ReopenWorkItems = 'REOPEN_WORK_ITEMS',
  ViewGsmQueueDashboard = 'VIEW_GSM_QUEUE_DASHBOARD',
  ViewUsers = 'VIEW_USERS'
}

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  userFullName: Scalars['String'];
  userId: Scalars['ID'];
};

export enum WarningEventType {
  FirstWarning = 'FIRST_WARNING',
  PossibleStudentSituation = 'POSSIBLE_STUDENT_SITUATION',
  QuestionableContent = 'QUESTIONABLE_CONTENT',
  SecondWarning = 'SECOND_WARNING',
  ThirdWarning = 'THIRD_WARNING',
  Violation = 'VIOLATION'
}

export type WarningTemplateMigrationResult = {
  __typename?: 'WarningTemplateMigrationResult';
  recordsMigrated?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type WebFilterWorkItem = WorkItem & {
  __typename?: 'WebFilterWorkItem';
  allowOrBlock?: Maybe<Scalars['String']>;
  apsIds?: Maybe<Array<Scalars['ID']>>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  blockReasons?: Maybe<Array<BlockReason>>;
  blockedUserId?: Maybe<Scalars['ID']>;
  bundleDigest?: Maybe<Scalars['String']>;
  bundled?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  contentUrl?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  customerId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  districtId: Scalars['ID'];
  districtIdShort?: Maybe<Scalars['String']>;
  districtInfo?: Maybe<DistrictInfo>;
  districtName?: Maybe<Scalars['String']>;
  districtNotes?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['String']>;
  events?: Maybe<Array<WorkItemEventRecord>>;
  extraInfo?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupIdShort?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  gsmEmailSetting?: Maybe<GsmEmailSetting>;
  id: Scalars['ID'];
  imageCacheIds?: Maybe<Array<Scalars['String']>>;
  inappropriateContentReasons?: Maybe<Array<InappropriateContentReason>>;
  incidentIds?: Maybe<Array<Scalars['ID']>>;
  ipSource?: Maybe<Scalars['String']>;
  itemData?: Maybe<Scalars['AWSJSON']>;
  logicalLocationId?: Maybe<Scalars['ID']>;
  ncmecId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['ID']>;
  occurrenceDate?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  safetyAudit?: Maybe<Scalars['Boolean']>;
  safetyRepId?: Maybe<Scalars['ID']>;
  searchTerms?: Maybe<Scalars['String']>;
  studentInfo?: Maybe<StudentInfo>;
  studentTimezone?: Maybe<Scalars['String']>;
  unbundled?: Maybe<Scalars['Boolean']>;
  userEmail?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userIdShort?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  workItemEntityType: WorkItemEntityType;
  workItemSource?: Maybe<WorkItemSource>;
  workItemStatus?: Maybe<WorkItemStatus>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export type WorkItem = {
  apsIds?: Maybe<Array<Scalars['ID']>>;
  attachments?: Maybe<Array<AttachmentInfo>>;
  blockReasons?: Maybe<Array<BlockReason>>;
  blockedUserId?: Maybe<Scalars['ID']>;
  bundleDigest?: Maybe<Scalars['String']>;
  bundled?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  customerId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  districtId: Scalars['ID'];
  districtIdShort?: Maybe<Scalars['String']>;
  districtInfo?: Maybe<DistrictInfo>;
  districtName?: Maybe<Scalars['String']>;
  districtNotes?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  events?: Maybe<Array<WorkItemEventRecord>>;
  extraInfo?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupIdShort?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  gsmEmailSetting?: Maybe<GsmEmailSetting>;
  id: Scalars['ID'];
  imageCacheIds?: Maybe<Array<Scalars['String']>>;
  inappropriateContentReasons?: Maybe<Array<InappropriateContentReason>>;
  incidentIds?: Maybe<Array<Scalars['ID']>>;
  itemData?: Maybe<Scalars['AWSJSON']>;
  logicalLocationId?: Maybe<Scalars['ID']>;
  ncmecId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  occurrenceDate?: Maybe<Scalars['String']>;
  safetyAudit?: Maybe<Scalars['Boolean']>;
  safetyRepId?: Maybe<Scalars['ID']>;
  studentInfo?: Maybe<StudentInfo>;
  studentTimezone?: Maybe<Scalars['String']>;
  unbundled?: Maybe<Scalars['Boolean']>;
  userEmail?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userIdShort?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  workItemEntityType: WorkItemEntityType;
  workItemSource?: Maybe<WorkItemSource>;
  workItemStatus?: Maybe<WorkItemStatus>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export enum WorkItemEntityType {
  Any = 'ANY',
  Calendar = 'CALENDAR',
  Canvas = 'CANVAS',
  File = 'FILE',
  FileComment = 'FILE_COMMENT',
  Hangout = 'HANGOUT',
  Message = 'MESSAGE',
  Speakup = 'SPEAKUP',
  Webfilter = 'WEBFILTER'
}

export type WorkItemEvent = {
  __typename?: 'WorkItemEvent';
  auditKey?: Maybe<Scalars['String']>;
  batch?: Maybe<Scalars['Boolean']>;
  bundleDigest?: Maybe<Scalars['String']>;
  bundled?: Maybe<Scalars['Boolean']>;
  contractWorker?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Scalars['String']>;
  finalOverride?: Maybe<Scalars['Boolean']>;
  payload?: Maybe<EventPayload>;
  unbundleType?: Maybe<WorkItemUnbundleType>;
  workItemId?: Maybe<Scalars['ID']>;
  workerId?: Maybe<Scalars['ID']>;
};

export type WorkItemEventInput = {
  auditKey?: InputMaybe<Scalars['String']>;
  batch?: InputMaybe<Scalars['Boolean']>;
  bundleDigest?: InputMaybe<Scalars['String']>;
  bundled?: InputMaybe<Scalars['Boolean']>;
  contractWorker?: InputMaybe<Scalars['Boolean']>;
  event?: InputMaybe<Scalars['String']>;
  finalOverride?: InputMaybe<Scalars['Boolean']>;
  payload?: InputMaybe<EventPayloadInput>;
  unbundleType?: InputMaybe<Scalars['String']>;
  workItemId?: InputMaybe<Scalars['ID']>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export type WorkItemEventRecord = {
  __typename?: 'WorkItemEventRecord';
  date?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  workerId?: Maybe<Scalars['ID']>;
  workerName?: Maybe<Scalars['String']>;
};

export type WorkItemEventsUpdateRequest = {
  __typename?: 'WorkItemEventsUpdateRequest';
  events: Array<WorkItemEvent>;
};

export type WorkItemEventsUpdateResponse = {
  __typename?: 'WorkItemEventsUpdateResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type WorkItemFeatureFlagInput = {
  customerId: Scalars['ID'];
  districtId: Scalars['ID'];
  groupId: Scalars['ID'];
  safetyAudit?: InputMaybe<Scalars['Boolean']>;
  workItemEntityType: WorkItemEntityType;
  workItemSource?: InputMaybe<WorkItemSource>;
};

export type WorkItemResponse = {
  __typename?: 'WorkItemResponse';
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type WorkItemSearchParametersInput = {
  completedDate?: InputMaybe<DateSearchParametersInput>;
  createdDate?: InputMaybe<DateSearchParametersInput>;
  districtId?: InputMaybe<Scalars['ID']>;
  events?: InputMaybe<Array<EventAction>>;
  fileName?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  hasIncidents?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  keyword?: InputMaybe<Scalars['String']>;
  occurrenceDate?: InputMaybe<DateSearchParametersInput>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  processedDate?: InputMaybe<DateSearchParametersInput>;
  sort: WorkItemSearchSortInput;
  userId?: InputMaybe<Scalars['ID']>;
  userIdShort?: InputMaybe<Scalars['Int']>;
  workItemStatus?: InputMaybe<Array<InputMaybe<WorkItemStatus>>>;
  workItemTypes?: InputMaybe<Array<WorkItemEntityType>>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export type WorkItemSearchResponse = {
  __typename?: 'WorkItemSearchResponse';
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  query?: Maybe<Scalars['AWSJSON']>;
  total: Scalars['Int'];
  workItems?: Maybe<Array<WorkItem>>;
};

export enum WorkItemSearchSortField {
  CompletedDate = 'COMPLETED_DATE',
  CreatedDate = 'CREATED_DATE',
  EntityType = 'ENTITY_TYPE',
  OccurrenceDate = 'OCCURRENCE_DATE',
  ProcessedDate = 'PROCESSED_DATE',
  Status = 'STATUS'
}

export type WorkItemSearchSortInput = {
  fieldName: WorkItemSearchSortField;
  order: SortOrder;
};

export enum WorkItemSource {
  Blocksi = 'BLOCKSI',
  Canvas = 'CANVAS',
  ContentKeeper = 'CONTENT_KEEPER',
  Deledao = 'DELEDAO',
  Email = 'EMAIL',
  GatShield = 'GAT_SHIELD',
  Goguardian = 'GOGUARDIAN',
  GoogleCalendar = 'GOOGLE_CALENDAR',
  GoogleChromeExtension = 'GOOGLE_CHROME_EXTENSION',
  GoogleDrive = 'GOOGLE_DRIVE',
  GoogleGmailArchive = 'GOOGLE_GMAIL_ARCHIVE',
  GoogleHangouts = 'GOOGLE_HANGOUTS',
  GooglePassthru = 'GOOGLE_PASSTHRU',
  GroupwiseEmail = 'GROUPWISE_EMAIL',
  Hapara = 'HAPARA',
  Iboss = 'IBOSS',
  Lightspeed = 'LIGHTSPEED',
  Linewize = 'LINEWIZE',
  MicrosoftOnedrive = 'MICROSOFT_ONEDRIVE',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  O365EmailArchive = 'O365_EMAIL_ARCHIVE',
  O365Passthru = 'O365_PASSTHRU',
  PaloAlto = 'PALO_ALTO',
  Securly = 'SECURLY',
  Speakup = 'SPEAKUP',
  Unspecified = 'UNSPECIFIED',
  Webfilter = 'WEBFILTER',
  Zscaler = 'ZSCALER'
}

export type WorkItemStateMachineStatus = {
  __typename?: 'WorkItemStateMachineStatus';
  lastExecutionId?: Maybe<Scalars['ID']>;
  locked: Scalars['Boolean'];
  state: Scalars['String'];
  stateHash: Scalars['String'];
  transitioningSince?: Maybe<Scalars['Int']>;
  uuid: Scalars['ID'];
};

export enum WorkItemStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum WorkItemTtl {
  Default = 'DEFAULT',
  NinetyDays = 'NINETY_DAYS',
  OneYear = 'ONE_YEAR'
}

export enum WorkItemUnbundleType {
  All = 'ALL',
  Self = 'SELF'
}

export type WorkItemWithIncident = {
  __typename?: 'WorkItemWithIncident';
  incident?: Maybe<Incident>;
  workItem?: Maybe<WorkItem>;
};

export type WorkerEmergencyContactCommunicationsAvailability = {
  __typename?: 'WorkerEmergencyContactCommunicationsAvailability';
  categories: Array<InappropriateContentReason>;
  digest: Scalars['Boolean'];
  email: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  text: Scalars['Boolean'];
};

export type WorkerEmergencyContactCommunicationsAvailabilityInput = {
  categories?: InputMaybe<Array<InputMaybe<InappropriateContentReason>>>;
  digest?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['Boolean']>;
};

export type WorkerEmergencyContactCommunicationsStatus = {
  __typename?: 'WorkerEmergencyContactCommunicationsStatus';
  acknowledgment?: Maybe<AcknowledgmentSource>;
  call?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type WorkerEmergencyContactCommunicationsStatusInput = {
  acknowledgment?: InputMaybe<AcknowledgmentSource>;
  call?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type WorkerPermissionInput = {
  permissionName: Scalars['String'];
  value: Scalars['String'];
};

export type WorkerSearchResult = {
  __typename?: 'WorkerSearchResult';
  workerId: Scalars['ID'];
  workerName: Scalars['String'];
};

type BaseWorkItem_ChatWorkItem_Fragment = { __typename?: 'ChatWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null };

type BaseWorkItem_GenericWorkItem_Fragment = { __typename?: 'GenericWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null };

type BaseWorkItem_SpeakupWorkItem_Fragment = { __typename?: 'SpeakupWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null };

type BaseWorkItem_ThirdPartyWorkItem_Fragment = { __typename?: 'ThirdPartyWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null };

type BaseWorkItem_WebFilterWorkItem_Fragment = { __typename?: 'WebFilterWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null };

export type BaseWorkItemFragment = BaseWorkItem_ChatWorkItem_Fragment | BaseWorkItem_GenericWorkItem_Fragment | BaseWorkItem_SpeakupWorkItem_Fragment | BaseWorkItem_ThirdPartyWorkItem_Fragment | BaseWorkItem_WebFilterWorkItem_Fragment;

export type FileFragment = { __typename?: 'ThirdPartyWorkItem', entityName?: string | null, entitySize?: number | null, folder?: boolean | null, lastModified?: string | null, lastModifiedBy?: string | null, remoteOwnerId?: string | null, revision?: number | null, sharedToUser?: boolean | null, remoteEntityId?: string | null, fileOwnerEmail?: string | null, contentType?: string | null };

export type HangoutFragment = { __typename?: 'ChatWorkItem', content?: string | null, messageId?: string | null, uniqueId?: string | null, author?: string | null, externalAuthor?: boolean | null };

export type CaptureDatadogMetricMutationVariables = Exact<{
  metrics: Array<DatadogMetric> | DatadogMetric;
  tags?: InputMaybe<Array<DatadogTag> | DatadogTag>;
  application: Scalars['String'];
  environment: Environment;
  workerId: Scalars['String'];
}>;


export type CaptureDatadogMetricMutation = { __typename?: 'Mutation', captureDatadogMetric: { __typename?: 'Empty', success?: boolean | null } };

export type CaptureKmmEventMutationVariables = Exact<{
  eventName: L1EventType;
  eventDate: Scalars['AWSDateTime'];
  workItemId: Scalars['String'];
  workerId: Scalars['String'];
  eventDetails?: InputMaybe<Array<InputMaybe<KmmEventDetail>> | InputMaybe<KmmEventDetail>>;
}>;


export type CaptureKmmEventMutation = { __typename?: 'Mutation', captureKmmEvent: { __typename?: 'Empty', success?: boolean | null } };

export type ChangeItemVisibilityTimeoutMutationVariables = Exact<{
  itemId: Scalars['ID'];
  timeoutSecs: Scalars['Int'];
}>;


export type ChangeItemVisibilityTimeoutMutation = { __typename?: 'Mutation', changeItemVisibilityTimeout: { __typename?: 'Empty', success?: boolean | null } };

export type DebugL1WorkItemMutationVariables = Exact<{
  debugInfo: Scalars['AWSJSON'];
  debugReason: Scalars['String'];
  workItemId: Scalars['String'];
  workerUsername: Scalars['String'];
}>;


export type DebugL1WorkItemMutation = { __typename?: 'Mutation', debugL1WorkItem: { __typename?: 'Empty', success?: boolean | null } };

export type LogEventMutationVariables = Exact<{
  source: LoggingSource;
  level: LoggingLevel;
  message: Scalars['String'];
  data?: InputMaybe<Scalars['AWSJSON']>;
}>;


export type LogEventMutation = { __typename?: 'Mutation', logEvent: { __typename?: 'Empty', success?: boolean | null } };

export type LogoutMutationVariables = Exact<{
  refreshToken: Scalars['String'];
  userPoolClientId: Scalars['String'];
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'Empty', success?: boolean | null } };

export type NewEventMutationVariables = Exact<{
  workItemId: Scalars['ID'];
  event: Scalars['String'];
  finalOverride: Scalars['Boolean'];
  batch: Scalars['Boolean'];
  payload: EventPayloadInput;
}>;


export type NewEventMutation = { __typename?: 'Mutation', newEvent: { __typename?: 'EventResult', success?: boolean | null } };

export type SendUiAnalyticsEventMutationVariables = Exact<{
  application: UiApplication;
  queue: UiQueue;
  action: UiEventAction;
  isHighPriority: Scalars['Boolean'];
  startDateTime: Scalars['AWSDateTime'];
  eventDateTime?: InputMaybe<Scalars['AWSDateTime']>;
  workItemId: Scalars['ID'];
}>;


export type SendUiAnalyticsEventMutation = { __typename?: 'Mutation', sendUIAnalyticsEvent?: { __typename?: 'Empty', success?: boolean | null } | null };

export type GetDownloadLinkQueryVariables = Exact<{
  customerId: Scalars['String'];
  logicalId: Scalars['String'];
  workItemType: Scalars['String'];
  targetFileName?: InputMaybe<Scalars['String']>;
  noCopy?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDownloadLinkQuery = { __typename?: 'Query', downloadLink?: { __typename?: 'DownloadLinkInfo', compressed?: boolean | null, url: string, file_size: number, item_type: string } | null };

export type GetFileCommentsQueryVariables = Exact<{
  commentId: Scalars['String'];
  contextCount?: InputMaybe<Scalars['Int']>;
}>;


export type GetFileCommentsQuery = { __typename?: 'Query', getFileComments?: { __typename?: 'FileCommentContent', blockedItem?: { __typename?: 'FileCommentBlockedItem', author?: string | null, blocked?: boolean | null, content?: string | null, id?: string | null, timestamp?: number | null, type?: string | null } | null, comments?: Array<{ __typename?: 'FileComment', anchor?: string | null, author?: string | null, blocked?: boolean | null, content?: string | null, id?: string | null, timestamp?: number | null, replies?: Array<{ __typename?: 'FileCommentReply', author?: string | null, blocked?: boolean | null, content?: string | null, id?: string | null, timestamp?: number | null, replyNumber?: number | null } | null> | null } | null> | null } | null };

export type GetMessageMetadataQueryVariables = Exact<{
  customerId: Scalars['String'];
  logicalId: Scalars['String'];
  workItemType: WorkItemEntityType;
}>;


export type GetMessageMetadataQuery = { __typename?: 'Query', getMessageMetadata?: { __typename?: 'MessageMetadata', sender: string, recipients?: string | null, subject?: string | null, content?: Array<string> | null, chat_context?: any | null, download_info?: { __typename?: 'DownloadLinkInfo', compressed?: boolean | null, url: string, file_size: number, item_type: string } | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, downloadUrl?: string | null, contentId?: string | null }> | null } | null };

export type GetWorkItemByIdQueryVariables = Exact<{
  workItemId: Scalars['String'];
}>;


export type GetWorkItemByIdQuery = { __typename?: 'Query', getWorkItem?: { __typename?: 'ChatWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, content?: string | null, messageId?: string | null, uniqueId?: string | null, author?: string | null, externalAuthor?: boolean | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'GenericWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'SpeakupWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'ThirdPartyWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, entityName?: string | null, entitySize?: number | null, folder?: boolean | null, lastModified?: string | null, lastModifiedBy?: string | null, remoteOwnerId?: string | null, revision?: number | null, sharedToUser?: boolean | null, remoteEntityId?: string | null, fileOwnerEmail?: string | null, contentType?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'WebFilterWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | null };

export type NextL1WorkItemBatchQueryVariables = Exact<{ [key: string]: never; }>;


export type NextL1WorkItemBatchQuery = { __typename?: 'Query', nextL1WorkItemBatch?: Array<{ __typename?: 'ChatWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, content?: string | null, messageId?: string | null, uniqueId?: string | null, author?: string | null, externalAuthor?: boolean | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'GenericWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'SpeakupWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'ThirdPartyWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, entityName?: string | null, entitySize?: number | null, folder?: boolean | null, lastModified?: string | null, lastModifiedBy?: string | null, remoteOwnerId?: string | null, revision?: number | null, sharedToUser?: boolean | null, remoteEntityId?: string | null, fileOwnerEmail?: string | null, contentType?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | { __typename?: 'WebFilterWorkItem', apsIds?: Array<string> | null, blockedUserId?: string | null, bundleDigest?: string | null, bundled?: boolean | null, completed?: string | null, customerId: string, created?: string | null, description?: string | null, districtId: string, districtIdShort?: string | null, districtName?: string | null, districtNotes?: string | null, entityId?: string | null, extraInfo?: string | null, groupId: string, groupIdShort?: string | null, groupName?: string | null, id: string, imageCacheIds?: Array<string> | null, inappropriateContentReasons?: Array<InappropriateContentReason> | null, incidentIds?: Array<string> | null, itemData?: any | null, logicalLocationId?: string | null, notes?: string | null, occurrenceDate?: string | null, safetyAudit?: boolean | null, safetyRepId?: string | null, studentTimezone?: string | null, unbundled?: boolean | null, userFullName?: string | null, userId: string, userIdShort?: string | null, userName?: string | null, workItemSource?: WorkItemSource | null, workItemStatus?: WorkItemStatus | null, workItemEntityType: WorkItemEntityType, workerId?: string | null, workerName?: string | null, gsmEmailSetting?: GsmEmailSetting | null, userEmail?: string | null, attachments?: Array<{ __typename?: 'AttachmentInfo', contentType?: string | null, id?: string | null, include?: boolean | null, name?: string | null, qualifier?: string | null, previewUrl?: string | null }> | null, blockReasons?: Array<{ __typename?: 'BlockReason', excerpts?: Array<string | null> | null, keyword?: string | null, moreExcerpts?: boolean | null, reason?: string | null, regex?: string | null, url?: string | null, cacheItem?: { __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null } | null, videoItem?: { __typename?: 'BlockedVideoCacheItem', contentHash?: string | null, sensitivity?: number | null, frames?: Array<{ __typename?: 'BlockedContentCacheItem', contentKey?: string | null, expiration?: any | null, url?: string | null }> | null } | null }> | null, events?: Array<{ __typename?: 'WorkItemEventRecord', date?: string | null, event?: string | null, workerId?: string | null, workerName?: string | null }> | null } | null> | null };

export type QueueStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type QueueStatisticsQuery = { __typename?: 'Query', queueStatistics?: { __typename?: 'QueueStatisticsList', queues: Array<{ __typename?: 'QueueStatistics', level1Count: number, level2Count: number, type: string }> } | null };

export type TranslateQueryVariables = Exact<{
  targetLanguage: Scalars['String'];
  textToTranslate: Array<Scalars['String']> | Scalars['String'];
  workItemId?: InputMaybe<Scalars['ID']>;
}>;


export type TranslateQuery = { __typename?: 'Query', translate?: Array<string | null> | null };

export const BaseWorkItemFragmentDoc = gql`
    fragment BaseWorkItem on WorkItem {
  attachments {
    contentType
    id
    include
    name
    qualifier
    previewUrl
  }
  apsIds
  blockedUserId
  blockReasons {
    cacheItem {
      contentKey
      expiration
      url
    }
    excerpts
    keyword
    moreExcerpts
    reason
    regex
    url
    videoItem {
      contentHash
      frames {
        contentKey
        expiration
        url
      }
      sensitivity
    }
  }
  bundleDigest
  bundled
  completed
  customerId
  created
  description
  districtId
  districtIdShort
  districtName
  districtNotes
  entityId
  events {
    date
    event
    workerId
    workerName
  }
  extraInfo
  groupId
  groupIdShort
  groupName
  id
  imageCacheIds
  inappropriateContentReasons
  incidentIds
  itemData
  logicalLocationId
  notes
  occurrenceDate
  safetyAudit
  safetyRepId
  studentTimezone
  unbundled
  userFullName
  userId
  userIdShort
  userName
  workItemSource
  workItemStatus
  workItemEntityType
  workerId
  workerName
  gsmEmailSetting
  userEmail
}
    `;
export const FileFragmentDoc = gql`
    fragment FILE on ThirdPartyWorkItem {
  entityName
  entitySize
  folder
  lastModified
  lastModifiedBy
  remoteOwnerId
  revision
  sharedToUser
  remoteEntityId
  fileOwnerEmail
  contentType
}
    `;
export const HangoutFragmentDoc = gql`
    fragment HANGOUT on ChatWorkItem {
  content
  messageId
  uniqueId
  author
  externalAuthor
}
    `;
export const CaptureDatadogMetricDocument = gql`
    mutation captureDatadogMetric($metrics: [DatadogMetric!]!, $tags: [DatadogTag!], $application: String!, $environment: Environment!, $workerId: String!) {
  captureDatadogMetric(
    metricEvent: {application: $application, environment: $environment, workerId: $workerId, metrics: $metrics, tags: $tags}
  ) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaptureDatadogMetricGQL extends Apollo.Mutation<CaptureDatadogMetricMutation, CaptureDatadogMetricMutationVariables> {
    document = CaptureDatadogMetricDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaptureKmmEventDocument = gql`
    mutation captureKmmEvent($eventName: L1EventType!, $eventDate: AWSDateTime!, $workItemId: String!, $workerId: String!, $eventDetails: [KmmEventDetail]) {
  captureKmmEvent(
    kmmEvent: {workerId: $workerId, workItemId: $workItemId, eventName: $eventName, eventDate: $eventDate, eventDetails: $eventDetails}
  ) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaptureKmmEventGQL extends Apollo.Mutation<CaptureKmmEventMutation, CaptureKmmEventMutationVariables> {
    document = CaptureKmmEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeItemVisibilityTimeoutDocument = gql`
    mutation changeItemVisibilityTimeout($itemId: ID!, $timeoutSecs: Int!) {
  changeItemVisibilityTimeout(itemId: $itemId, timeoutSecs: $timeoutSecs) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeItemVisibilityTimeoutGQL extends Apollo.Mutation<ChangeItemVisibilityTimeoutMutation, ChangeItemVisibilityTimeoutMutationVariables> {
    document = ChangeItemVisibilityTimeoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DebugL1WorkItemDocument = gql`
    mutation debugL1WorkItem($debugInfo: AWSJSON!, $debugReason: String!, $workItemId: String!, $workerUsername: String!) {
  debugL1WorkItem(
    l1DebugEvent: {debugInfo: $debugInfo, debugReason: $debugReason, workItemId: $workItemId, workerUsername: $workerUsername}
  ) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DebugL1WorkItemGQL extends Apollo.Mutation<DebugL1WorkItemMutation, DebugL1WorkItemMutationVariables> {
    document = DebugL1WorkItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogEventDocument = gql`
    mutation logEvent($source: LoggingSource!, $level: LoggingLevel!, $message: String!, $data: AWSJSON) {
  logEvent(source: $source, level: $level, message: $message, data: $data) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogEventGQL extends Apollo.Mutation<LogEventMutation, LogEventMutationVariables> {
    document = LogEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogoutDocument = gql`
    mutation logout($refreshToken: String!, $userPoolClientId: String!) {
  logout(refreshToken: $refreshToken, userPoolClientId: $userPoolClientId) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutGQL extends Apollo.Mutation<LogoutMutation, LogoutMutationVariables> {
    document = LogoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewEventDocument = gql`
    mutation newEvent($workItemId: ID!, $event: String!, $finalOverride: Boolean!, $batch: Boolean!, $payload: EventPayloadInput!) {
  newEvent(
    request: {workItemId: $workItemId, event: $event, finalOverride: $finalOverride, batch: $batch, payload: $payload}
  ) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewEventGQL extends Apollo.Mutation<NewEventMutation, NewEventMutationVariables> {
    document = NewEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendUiAnalyticsEventDocument = gql`
    mutation sendUIAnalyticsEvent($application: UIApplication!, $queue: UIQueue!, $action: UIEventAction!, $isHighPriority: Boolean!, $startDateTime: AWSDateTime!, $eventDateTime: AWSDateTime, $workItemId: ID!) {
  sendUIAnalyticsEvent(
    application: $application
    queue: $queue
    action: $action
    isHighPriority: $isHighPriority
    startDateTime: $startDateTime
    eventDateTime: $eventDateTime
    workItemId: $workItemId
  ) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendUiAnalyticsEventGQL extends Apollo.Mutation<SendUiAnalyticsEventMutation, SendUiAnalyticsEventMutationVariables> {
    document = SendUiAnalyticsEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDownloadLinkDocument = gql`
    query getDownloadLink($customerId: String!, $logicalId: String!, $workItemType: String!, $targetFileName: String, $noCopy: Boolean) {
  downloadLink(
    customerId: $customerId
    logicalId: $logicalId
    workItemType: $workItemType
    targetFileName: $targetFileName
    noCopy: $noCopy
  ) {
    compressed
    url
    file_size
    item_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDownloadLinkGQL extends Apollo.Query<GetDownloadLinkQuery, GetDownloadLinkQueryVariables> {
    document = GetDownloadLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFileCommentsDocument = gql`
    query getFileComments($commentId: String!, $contextCount: Int) {
  getFileComments(commentId: $commentId, contextCount: $contextCount) {
    blockedItem {
      author
      blocked
      content
      id
      timestamp
      type
    }
    comments {
      anchor
      author
      blocked
      content
      id
      timestamp
      replies {
        author
        blocked
        content
        id
        timestamp
        replyNumber
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFileCommentsGQL extends Apollo.Query<GetFileCommentsQuery, GetFileCommentsQueryVariables> {
    document = GetFileCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMessageMetadataDocument = gql`
    query getMessageMetadata($customerId: String!, $logicalId: String!, $workItemType: WorkItemEntityType!) {
  getMessageMetadata(
    customerId: $customerId
    logicalId: $logicalId
    workItemType: $workItemType
  ) {
    download_info {
      compressed
      url
      file_size
      item_type
    }
    sender
    recipients
    subject
    content
    attachments {
      contentType
      id
      include
      name
      qualifier
      downloadUrl
      contentId
    }
    chat_context
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMessageMetadataGQL extends Apollo.Query<GetMessageMetadataQuery, GetMessageMetadataQueryVariables> {
    document = GetMessageMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWorkItemByIdDocument = gql`
    query getWorkItemById($workItemId: String!) {
  getWorkItem(workItemId: $workItemId) {
    ...BaseWorkItem
    ...FILE
    ...HANGOUT
  }
}
    ${BaseWorkItemFragmentDoc}
${FileFragmentDoc}
${HangoutFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWorkItemByIdGQL extends Apollo.Query<GetWorkItemByIdQuery, GetWorkItemByIdQueryVariables> {
    document = GetWorkItemByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NextL1WorkItemBatchDocument = gql`
    query nextL1WorkItemBatch {
  nextL1WorkItemBatch {
    ...BaseWorkItem
    ...FILE
    ...HANGOUT
  }
}
    ${BaseWorkItemFragmentDoc}
${FileFragmentDoc}
${HangoutFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NextL1WorkItemBatchGQL extends Apollo.Query<NextL1WorkItemBatchQuery, NextL1WorkItemBatchQueryVariables> {
    document = NextL1WorkItemBatchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueueStatisticsDocument = gql`
    query queueStatistics {
  queueStatistics {
    queues {
      level1Count
      level2Count
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueueStatisticsGQL extends Apollo.Query<QueueStatisticsQuery, QueueStatisticsQueryVariables> {
    document = QueueStatisticsDocument;
    client = 'noAuth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TranslateDocument = gql`
    query translate($targetLanguage: String!, $textToTranslate: [String!]!, $workItemId: ID) {
  translate(
    targetLanguage: $targetLanguage
    textToTranslate: $textToTranslate
    workItemId: $workItemId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TranslateGQL extends Apollo.Query<TranslateQuery, TranslateQueryVariables> {
    document = TranslateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }